import ContentBannerContainer from './content-banner.container';
import ContentBanner from './content-banner.component';
import { IContentBannerProps } from './content-banner.types';

export { ContentBanner, IContentBannerProps };

export default ContentBannerContainer;
